import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-request-changes-dialog',
  templateUrl: './request-changes-dialog.component.html',
  styleUrls: ['./request-changes-dialog.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule
]
})
export class RequestChangesDialogComponent {
  userPrompt: string = '';

  constructor(
    public dialogRef: MatDialogRef<RequestChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSendFeedback(): void {
    this.dialogRef.close(this.userPrompt);
  }
}
